export var PortalActions;
(function (PortalActions) {
    PortalActions["FETCH_PORTAL_DATA"] = "FETCH_PORTAL_DATA";
    PortalActions["JOIN_TEAM_ACCOUNTS"] = "JOIN_TEAM_ACCOUNTS";
})(PortalActions || (PortalActions = {}));
export var BootstrapActions;
(function (BootstrapActions) {
    BootstrapActions["FETCH_BOOTSTRAP_DATA"] = "FETCH_BOOTSTRAP_DATA";
})(BootstrapActions || (BootstrapActions = {}));
export var MembersActions;
(function (MembersActions) {
    MembersActions["FETCH_MEMBERS"] = "FETCH_MEMBERS";
    MembersActions["SEARCH_MEMBERS"] = "SEARCH_MEMBERS";
    MembersActions["REMOVE_MEMBER"] = "REMOVE_MEMBER";
    MembersActions["ADD_MEMBERS"] = "ADD_MEMBERS";
    MembersActions["ADD_ADMIN_ROLE"] = "ADD_ADMIN_ROLE";
    MembersActions["REMOVE_ADMIN_ROLE"] = "REMOVE_ADMIN_ROLE";
})(MembersActions || (MembersActions = {}));
export var BudgetsActions;
(function (BudgetsActions) {
    BudgetsActions["FETCH_TEAM_ACCOUNT_BUDGETS"] = "FETCH_TEAM_ACCOUNT_BUDGETS";
    BudgetsActions["ADD_TEAM_ACCOUNT_BUDGET"] = "ADD_TEAM_ACCOUNT_BUDGET";
    BudgetsActions["DELETE_BUDGET"] = "DELETE_BUDGET";
    BudgetsActions["FETCH_TEAM_ACCOUNT_BUDGET_CONFIGURATION_OPTIONS"] = "FETCH_TEAM_ACCOUNT_BUDGET_CONFIGURATION_OPTIONS";
})(BudgetsActions || (BudgetsActions = {}));
export var GroupActions;
(function (GroupActions) {
    GroupActions["ADD_TEAM_ACCOUNT_GROUP"] = "ADD_TEAM_ACCOUNT_GROUP";
    GroupActions["FETCH_TEAM_ACCOUNT_GROUPS"] = "FETCH_TEAM_ACCOUNT_GROUPS";
    GroupActions["DELETE_TEAM_ACCOUNT_GROUP"] = "DELETE_TEAM_ACCOUNT_GROUP";
    GroupActions["FETCH_TEAM_ACCOUNT_GROUP_BY_ID"] = "FETCH_TEAM_ACCOUNT_GROUP_BY_ID";
})(GroupActions || (GroupActions = {}));
export var GroupsMembersActions;
(function (GroupsMembersActions) {
    GroupsMembersActions["FETCH_TEAM_ACCOUNT_GROUP_MEMBERS"] = "FETCH_TEAM_ACCOUNT_GROUP_MEMBERS";
    GroupsMembersActions["REMOVE_TEAM_ACCOUNT_GROUP_MEMBERS"] = "REMOVE_TEAM_ACCOUNT_GROUP_MEMBERS";
    GroupsMembersActions["ADD_TEAM_ACCOUNT_GROUP_MEMBERS"] = "ADD_TEAM_ACCOUNT_GROUP_MEMBERS";
})(GroupsMembersActions || (GroupsMembersActions = {}));
export var UiActions;
(function (UiActions) {
    UiActions["SELECT_TEAM_ACCOUNT"] = "SELECT_TEAM_ACCOUNT";
})(UiActions || (UiActions = {}));
